import React, { FC } from "react";
import { Link } from "react-router-dom";
import { Link as MLink } from "@mui/material";
import { LinkBaseProps } from "@mui/material/Link/Link";
import { TypographyProps } from "@mui/material/Typography";

export const VTextLink: FC<
    {
        to: string;
        children?: React.ReactNode;
    } & Partial<
        Omit<
            LinkBaseProps & {
                TypographyClasses?: TypographyProps["classes"];
                underline?: "none" | "hover" | "always";
            },
            "href"
        >
    >
> = ({ to, children, ...rest }) => (
    <Link to={to}>
        <MLink variant="body1" component="span" {...rest} underline="hover">
            {children}
        </MLink>
    </Link>
);
